// @ts-nocheck
// SignatureModule.jsx
import React from 'react';
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  Divider,
  useTheme,
  TextField,
} from '@mui/material';
import { SecondaryButton } from 'components/__v2__/Button/ReusableButton';
import PropTypes from 'prop-types';
import { StyledTextarea } from 'components/__v5__/StyledTextarea/StyledTextarea';
import InputField from 'components/atoms/InputField';
import SignatureField from './SignatureField';
import SignatureCanvas from './SignatureCanvas';

const SignatureModule = ({
  savedSignature,
  isSignatureLoading,
  sigCanvas,
  isDialogOpen,
  setIsDialogOpen,
  toggleSignaturePad,
  removeSignature,
  clear,
  saveSignature,
  setComment,
  comment,
  signatoryName,
  setSignatoryName,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <Typography
          sx={{ color: theme.palette.normalText.dark }}
          variant="subtitle2"
          mt={2}
        >
          Signatory Name*
        </Typography>

        <Box mb={1}>
          <InputField
            variant="outlined"
            placeholder="Enter your name"
            value={signatoryName}
            onChange={(e) => setSignatoryName(e.target.value)}
          />
        </Box>
      </Box>
      <Typography
        variant="subtitle1"
        sx={{ color: theme.palette.normalText.dark }}
      >
        Signature here
      </Typography>
      <SignatureField
        toggleSignaturePad={toggleSignaturePad}
        savedSignature={savedSignature?.file}
        isSignatureLoading={isSignatureLoading}
      />
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <DialogContent>
          <SignatureCanvas
            sigCanvas={sigCanvas}
            clear={clear}
            saveSignature={saveSignature}
            setIsDialogOpen={setIsDialogOpen}
            isSignatureLoading={isSignatureLoading}
            setComment={setComment}
          />
        </DialogContent>
      </Dialog>
      <Box mt={2}>
        <SecondaryButton variant="outlined" onClick={removeSignature}>
          Clear
        </SecondaryButton>
      </Box>

      <Box>
        <Typography
          sx={{ color: theme.palette.normalText.dark }}
          variant="subtitle2"
          mt={2}
        >
          Comment
        </Typography>

        <StyledTextarea
          sx={{
            '& .MuiInputBase-input': {
              color: theme.palette.primary.textColor,
            },
          }}
          variant="outlined"
          minRows={3}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        {comment?.length > 512 && (
          <Typography mb={1} color="error" variant="caption">
            Comment should not exceed 512 characters
          </Typography>
        )}
      </Box>
      <Typography
        variant="body2"
        my={2}
        sx={{ color: theme.palette.normalText.dark }}
      >
        By submitting this form, I understand and acknowledge that the signature
        I have drawn above is the legal electronic representation of my
        signature.
      </Typography>

      <Divider />
    </Box>
  );
};

export default SignatureModule;

SignatureModule.propTypes = {
  savedSignature: PropTypes.object.isRequired,
  isSignatureLoading: PropTypes.bool.isRequired,
  sigCanvas: PropTypes.object.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  toggleSignaturePad: PropTypes.func.isRequired,
  removeSignature: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  saveSignature: PropTypes.func.isRequired,
};
